export const faqContent = [
    {
        question: 'assetAvailableQuestion',
        answer: 'assetAvailableAnswer'
    },
    {
        question: 'fractionalisedNFTQuestion',
        answer: 'fractionalisedNFTAnswer'
    },
    {
        question: 'assetOwnerQuestion',
        answer: 'assetOwnerAnswer'
    },
    {
        question: 'shareBuyerQuestion',
        answer: 'shareBuyerAnswer'
    },
    {
        question: 'sharesPerAssetQuestion',
        answer: 'sharesPerAssetAnswer'
    },
    {
        question: 'assetVerificationQuestion',
        answer: 'assetVerificationAnswer'
    },
    {
        question: 'ownAssetListingQuestion',
        answer: 'ownAssetListingAnswer'
    },
    {
        question: 'companyAsAgentQuestion',
        answer: 'companyAsAgentAnswer'
    },
    {
        question: 'companyFeesQuestion',
        answer: 'companyFeesAnswer'
    }
];
